// Catálogo de tarjetas aceptadas para ofertas: id que se guarda en Firestore
// (offer.acceptedCards) + logo. Un solo lugar para no duplicar imports en
// cada formulario/vista que necesite listar o mostrar tarjetas.
import visa from "../imgs/visa.png";
import mastercard from "../imgs/mastercard.png";
import amex from "../imgs/amex.png";
import diners from "../imgs/diners.png";
import maestro from "../imgs/maestro.png";

export const CARD_OPTIONS = [
  { id: "visa", label: "Visa", img: visa },
  { id: "mastercard", label: "Mastercard", img: mastercard },
  { id: "amex", label: "American Express", img: amex },
  { id: "diners", label: "Diners Club", img: diners },
  { id: "maestro", label: "Maestro", img: maestro },
];
